import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-folder",
  "use": "icon-folder-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-folder\"><path d=\"M896 967.111111h-768C57.315556 967.111111 0 908.885333 0 837.091556V186.88C0 115.114667 57.315556 56.888889 128 56.888889h183.466667A127.857778 127.857778 0 0 1 426.666667 130.56l26.453333 56.348444H896c70.684444 0 128 58.225778 128 130.048v520.135112C1024 908.885333 966.684444 967.111111 896 967.111111zM85.333333 437.447111v399.644445c0 23.921778 19.114667 43.320889 42.666667 43.320888h768c23.552 0 42.666667-19.399111 42.666667-43.320888v-399.644445H85.333333z m0-86.698667h853.333334v-33.792c0-23.950222-19.114667-43.349333-42.666667-43.349333H426.666667a42.609778 42.609778 0 0 1-38.4-24.718222l-37.973334-80.611556a42.609778 42.609778 0 0 0-38.826666-24.689777H128c-23.552 0-42.666667 19.399111-42.666667 43.320888v163.84z\" p-id=\"6770\" fill=\"#4D4D4D\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/folder.svg
// module id = XXSE
// module chunks = 15 16